"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.MyElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const MyElement = props => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  className: "special-component",
  children: "this is a JS element"
});
exports.MyElement = MyElement;